<div class="test-login-selector">
  <div class="test-login-selector__label">Test accounts</div>
  <div class="test-login-selector__buttons">
    @for (account of accounts; track $index) {
      <button
        type="button"
        class="btn btn-outline-dark btn-sm"
        [disabled]="!account[0]"
        (click)="loginAs(account)"
      >
        {{ account[0] || '—' }}
      </button>
    }
  </div>
</div>
